__turbopack_context__.v({
  "appGrid": "integrations-module__SVatDW__appGrid",
  "appIdentity": "integrations-module__SVatDW__appIdentity",
  "banner": "integrations-module__SVatDW__banner",
  "card": "integrations-module__SVatDW__card",
  "cardAction": "integrations-module__SVatDW__cardAction",
  "categories": "integrations-module__SVatDW__categories",
  "categoryNav": "integrations-module__SVatDW__categoryNav",
  "categorySelect": "integrations-module__SVatDW__categorySelect",
  "container": "integrations-module__SVatDW__container",
  "description": "integrations-module__SVatDW__description",
  "directory": "integrations-module__SVatDW__directory",
  "empty": "integrations-module__SVatDW__empty",
  "group": "integrations-module__SVatDW__group",
  "groupHeading": "integrations-module__SVatDW__groupHeading",
  "help": "integrations-module__SVatDW__help",
  "initial": "integrations-module__SVatDW__initial",
  "layout": "integrations-module__SVatDW__layout",
  "page": "integrations-module__SVatDW__page",
  "resultSummary": "integrations-module__SVatDW__resultSummary",
  "results": "integrations-module__SVatDW__results",
  "search": "integrations-module__SVatDW__search",
  "textLink": "integrations-module__SVatDW__textLink",
  "title": "integrations-module__SVatDW__title",
});
